import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, cn } from '@costar-ui/cosmos';
import baseCard from './base-card.esm.js';

var tvObject = getTvObject(_objectSpread2(_objectSpread2({}, baseCard), {}, {
  base: cn(baseCard.base, 'rounded-lg').split(' ')
}));
var nextCard = tvObject;

export { nextCard as default };
//# sourceMappingURL=next-card.esm.js.map
